import { ComponentProps, useState } from "react";

import { twMerge } from "tailwind-merge";

import { fallbackValidatorImage } from "entities/validator";
import { Validator } from "shared/api/cosmos/use-validators-query";
import { Dialog } from "shared/ui/dialog";
import { Icon } from "shared/ui/icon";

import { SelectValidatorDialog } from "./select-validator-dialog";

type Props = {
  name: string | undefined;
  onSelect: (validator: Validator) => void;
};

export const SelectValidator = (props: ComponentProps<"button"> & Props) => {
  const { name, className, onSelect } = props;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Dialog onOpenChange={setIsOpen} open={isOpen}>
        <div className={twMerge("flex flex-col", className)}>
          <label className="text-pickledBluewood mb-1.5 block text-xs">
            Select Validator
          </label>
          <button
            className={twMerge(
              "border-dawnPink2 bg-desertStorm font-ptm hover:border-basket-ball-orange flex w-full items-center gap-x-2 rounded-lg border p-3 transition-colors"
            )}
            onClick={() => {
              setIsOpen(true);
            }}
          >
            <span className="bg-iron relative flex size-[22px] items-center justify-center rounded-full border-[0.5px] border-white">
              {name && (
                <img
                  alt="validator"
                  className="absolute inset-0"
                  src={fallbackValidatorImage}
                />
              )}
            </span>
            <span className="translate-y-px">
              {name ? name : "Select Validator"}
            </span>
            <Icon className="ml-auto" name="arrowRightSelect" />
          </button>
        </div>

        <SelectValidatorDialog
          onDelegate={(validator) => {
            onSelect(validator);
            setIsOpen(false);
          }}
        />
      </Dialog>
    </>
  );
};
